import { useSpaceSize } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function useListContentStyle() {
  return {
    paddingTop: useSpaceSize("medium"),
    paddingBottom: useSpaceSize("large") + useSafeAreaInsets().bottom,
    paddingHorizontal: useSpaceSize("medium"),
  };
}
